import moment from 'moment-timezone';

/**
 * A custom hook to calculate and return the formatted renewal time.
 * @param {string | null | undefined} creditsLastReset - The ISO string of the last reset date.
 * @returns {string} The formatted time of renewal (e.g., "10:30 AM") or an empty string.
 */
export const useRenewalTime = (creditsLastReset, timezone) => {  
  try {
    if (!creditsLastReset || !timezone) return '';

    const renewalTime = moment.tz(creditsLastReset, timezone).add(1, 'days');
    return renewalTime.format('h:mm A');
  } catch (error) {
    console.error("Error formatting renewal date:", error);
    return '';
  }
};